import * as React from "react";
const SvgCellClose = (props) => (React.createElement("svg", Object.assign({ viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M1.871 1.871V22.13H22.13V1.87H12ZM3.38 3.38H20.62V20.62H3.38V12Zm3.935 7.873v1.496h9.372v-1.496H12Z", style: {
            clipRule: "evenodd",
            fill: "currentColor",
            fillRule: "evenodd",
        } })));
export default SvgCellClose;
